//@ts-nocheck
import React, { useState, useRef } from 'react'
import { Transforms, Node, Editor } from 'slate'
import { ReactEditor } from 'slate-react'
import { ModalBody, ModalHeader, ModalFooter, Button, ButtonGroup, Icon } from '../../../../../../index'

import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';
import { ImageEditForm } from './ImageEditForm'
//@ts-ignore
import styles from './style.module.css'
import './style.css'
import { handleImageError } from './withImage'
import ImageSizeField from './ImageSizeField'
import classNames from 'classnames'
import { getInitialWidthHeight, calculateImageDimensions, isPositiveNumber } from './utils';

export const ImageEditModal = ({ element, editor, type, ...props }) => {
  const [updatedFormData, setUpdatedFormData] = useState()
  const [hasError, setHasError] = useState(false)
  const [naturalImageWH, setNaturalImageWH] = useState();
  const imagePreviewRef = useRef(null);
  const imageSizeInputEnabled = props.imageSizeInputEnabled;

  const updateFormData = (formData) => {
    if (imageSizeInputEnabled) {
      imagePreviewRef.current.style.width = formData.width && isPositiveNumber(formData.width) ? `${formData.width}px` : 'auto';
      imagePreviewRef.current.style.height = formData.height && isPositiveNumber(formData.height) ? `${formData.height}px` : 'auto';
    }
    setUpdatedFormData(prev => ({ ...prev, ...formData }))
  }

  const handleFormSubmit = (values) => {
    let fields = { ...values }

    if (fields['inline']) {
      if (fields['position'] === 'center' || !fields['position']) {
        fields['position'] = 'left'
      }
    }
    const path = ReactEditor.findPath(editor, element)

    const newAttributes = {
      ...element.attrs,
      "redactor-attributes": {
        ...element.attrs?.["redactor-attributes"]
      },
      style: {
        ...element.attrs?.style
      }
    }
    Object.entries(fields).forEach(([f, v]) => {
      const field = f
      const value: any = v
      if (value && value !== '') {
        newAttributes["redactor-attributes"][field] = value
        if (field === 'inline') {
          newAttributes['inline'] = value
          newAttributes.style['width'] = Number(newAttributes['width']) ? `${newAttributes['width']}px` : newAttributes['width']
        }

        if (field === 'alt') {
          if (type === 'asset')
            newAttributes['asset-alt'] = value.trim();
          else
            newAttributes['alt'] = value
        }

        if (field === 'url') {
          newAttributes['url'] = value
        }
        if (field === 'caption' || field === 'anchorLink') {
          if (type === 'asset') {
            if (field === 'caption')
              newAttributes['asset-caption'] = value.trim();
            else newAttributes['link'] = value.trim();
          }
          else
            newAttributes[field] = value.trim()
        }

        if (field === 'position') {
          if (type === 'asset') {
            newAttributes['position'] = value;
          }
          if (imageSizeInputEnabled) {
            delete newAttributes.style["width"]
            delete newAttributes.style["height"]
            delete newAttributes.style["max-width"]
            delete newAttributes['width']
            delete newAttributes['height']
            delete newAttributes['max-width']
            if (value === 'none') {
              newAttributes["redactor-attributes"]['position'] = 'none'
              delete newAttributes.style["text-align"]
              delete newAttributes.style["float"]

              if (fields.width) newAttributes['width'] = fields.width
              if (fields.height) newAttributes['height'] = fields.height
            } else {
              newAttributes.style["text-align"] = value
              newAttributes["redactor-attributes"]['position'] = value

              if (value !== 'center') {
                if (fields.width) {
                  newAttributes['width'] = fields.width
                  newAttributes['max-width'] = fields.width
                  newAttributes.style["width"] = `${fields.width}px`
                  newAttributes.style["max-width"] = `${fields.width}px`
                }
                if (fields.height) {
                  newAttributes['height'] = fields.height
                  // newAttributes.style["height"] = `${fields.height}px`
                }
                newAttributes.style["float"] = value
              }
              else {
                if (newAttributes['max-width']) {
                  // newAttributes['width'] = newAttributes['max-width']
                  delete newAttributes.style["float"]
                  delete newAttributes.style["width"]
                  delete newAttributes.style["max-width"]
                  delete newAttributes['max-width']
                  delete newAttributes.style["height"]
                }
                if (fields.width) newAttributes['width'] = fields.width
                if (fields.height) newAttributes['height'] = fields.height
              }
            }
          } else {
            if (value === 'none') {
              newAttributes["redactor-attributes"]['position'] = 'none'
              delete newAttributes.style["text-align"]
              delete newAttributes.style["text-align"]
              delete newAttributes.style["float"]
              delete newAttributes.style["width"]
              delete newAttributes.style["max-width"]
              delete newAttributes['max-width']
            } else {
              newAttributes.style["text-align"] = value
              newAttributes["redactor-attributes"]['position'] = value

              if (value !== 'center') {
                if (newAttributes['max-width']) {
                  newAttributes.style["max-width"] = Number(newAttributes['max-width']) ? `${newAttributes['max-width']}px` : newAttributes['max-width']
                  newAttributes['max-width'] = newAttributes['max-width']
                  newAttributes.style["width"] = Number(newAttributes['width']) ? `${newAttributes['width']}px` : newAttributes['width']
                  newAttributes['width'] = newAttributes.width
                }
                else {
                  newAttributes.style["max-width"] = Number(newAttributes['max-width']) ? `${newAttributes['max-width']}px` : newAttributes['max-width']
                  newAttributes['max-width'] = newAttributes['width']
                }
                newAttributes.style["float"] = value
              }
              else {
                if (newAttributes['max-width']) {
                  newAttributes['width'] = newAttributes['max-width']
                  delete newAttributes.style["float"]
                  delete newAttributes.style["width"]
                  delete newAttributes.style["max-width"]
                  delete newAttributes['max-width']
                }
              }
            }
          }
        }
        if (field === 'target') {
          newAttributes.target = value ? '_blank' : '_self';
        }
      } else {
        if (field === 'position') {
          delete newAttributes.style["text-align"]
        }
        delete newAttributes[field]
        delete newAttributes["redactor-attributes"][field]
      }
    })

    let node = Node.get(editor, path)
    let newNode = cloneDeep(node);
    newNode.attrs = newAttributes;
    if (newAttributes.inline && !Editor.isInline(editor, node)) {
      Transforms.removeNodes(editor, { at: path })
      const inlineImage = {
        type: 'p',
        children: [
          newNode,
        ]
      }
      Transforms.insertNodes(editor, inlineImage, { at: path })
    } else if (!newAttributes.inline && Editor.isInline(editor, node)) {
      // remove the image element from p tag in case inline is disabled after enabling it;
      // removing the node from p tag
      Transforms.removeNodes(editor, { at: path });
      // removing path last item
      path.pop();
      Transforms.insertNodes(editor, newNode, { at: path })
    } else {
      Transforms.setNodes(editor, { attrs: newAttributes }, { at: path })
    }

    props.closeModal()
  }
  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    if (!naturalWidth || !naturalHeight) return;
    let width = updatedFormData?.width || element?.attrs?.width || element?.attrs?.["redactor-attributes"]?.width;
    if (width && !isPositiveNumber(width)) width = undefined;
    let height = updatedFormData?.height || element?.attrs?.height || element?.attrs?.["redactor-attributes"]?.height;
    if (height && !isPositiveNumber(height)) height = undefined;
    setNaturalImageWH(getInitialWidthHeight(naturalWidth, naturalHeight, width, height))
  }

  const modalContainerClass = classNames({
    [styles['scrte-form-container']]: !imageSizeInputEnabled,
    [styles['scrte-img-ele-form-container-big']]: imageSizeInputEnabled
  })

  const imageContainerClass = classNames({
    [styles['asset-edit-thumbnail']]: imageSizeInputEnabled,
    [styles['scrte-img-ele-image-container-big']]: imageSizeInputEnabled
  })
  const imagePreviewClass = classNames({
    [styles['scrte-img-ele-image-preview-big']]: imageSizeInputEnabled,
    [styles['modal']]: !imageSizeInputEnabled
  })
  const imageEditFormClass = classNames({
    [styles['edit-form']]: !imageSizeInputEnabled,
    [styles['scrte-img-ele-field-container-big']]: imageSizeInputEnabled
  })

  return (
    <div className='edit-asset-modal-wrapper cs-auto-draft-modal'>
      <ModalHeader
        title="Edit Image Properties"
        closeModal={props.closeModal}
      />

      <ModalBody>
        <div className={modalContainerClass}>

          <div className={imageContainerClass}>
            <img onLoad={handleImageLoad} ref={imagePreviewRef}
              src={type === 'asset' ? element.attrs?.['asset-link'] : element.attrs.url}
              className={imagePreviewClass}
              onError={handleImageError}
              data-testid={'scrte-image-element'} />
          </div>

          <div className={imageEditFormClass}>
            <ImageEditForm
              type={type}
              className={styles['scrte-form']}
              attributes={{
                ...element?.attrs,
                ...element?.attrs?.["redactor-attributes"]
              }}
              updateFormData={updateFormData}
              hasError={{ value: hasError, callback: setHasError }}
            >
              {imageSizeInputEnabled && <ImageSizeField
                naturalImageWH={naturalImageWH}
                attributes={calculateImageDimensions(updatedFormData, element)}
                hasError={{ value: hasError, callback: setHasError }}
                updateFormData={updateFormData}
              />}
            </ImageEditForm>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <ButtonGroup>
          <Button version="v2" key="cancel" buttonType="tertiary" onClick={() => props.closeModal()} data-testid={'scrte-cancel'}>
            Cancel
          </Button>
          <Button
            version="v2"
            key="add"
            disabled={hasError}
            onClick={() => {
              handleFormSubmit(updatedFormData)
            }}
            data-testid={'scrte-submit'}
          >
            Save
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </div >
  )
}
